import React from "react";
import { motion } from "framer-motion";

const Herosection = () => {
  const textVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  const buttonVariant = {
    hidden: { scale: 0.8, opacity: 0 },
    visible: { scale: 1, opacity: 1, transition: { duration: 0.6 } },
  };

  return (
    <div className="relative flex h-screen bg-black text-white overflow-hidden">
      {/* Background Section */}
      <div className="relative flex-1 flex items-center justify-center">
        <motion.div
          className="absolute inset-0 w-full h-full"
          initial={{ scale: 1.1 }}
          animate={{ scale: 1 }}
          transition={{
            scale: {
              duration: 5,
              ease: "linear",
            },
          }}
        >
          <img
            src="/hero2.jpg"
            alt="DR Cultivar"
            className="w-full h-full object-cover"
          />
        </motion.div>

        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black opacity-75"></div>

        {/* Content Section */}
        <div className="relative z-10 max-w-2xl px-8 text-center md:text-left">
          <motion.p
            className="text-green-400 font-semibold tracking-wider uppercase"
            variants={textVariant}
            initial="hidden"
            animate="visible"
          >
            Explore Premium Cultivars
          </motion.p>
          <motion.h1
            className="text-5xl md:text-7xl font-extrabold leading-tight mt-4"
            variants={textVariant}
            initial="hidden"
            animate="visible"
          >
            DR Cultivar
          </motion.h1>
          <motion.p
            className="mt-4 text-gray-300 text-lg"
            variants={textVariant}
            initial="hidden"
            animate="visible"
          >
            DR is a premium cultivar known for its distinctive balance of flavors and uplifting effects. Whether you're seeking relaxation or a vibrant experience, this cultivar delivers unparalleled quality and enjoyment.
          </motion.p>
          <motion.button
            className="mt-6 px-8 py-3 border-2 border-green-400 text-green-400 font-medium rounded-md hover:bg-green-400 hover:text-black transition duration-300 shadow-lg hover:shadow-green-500/50"
            variants={buttonVariant}
            initial="hidden"
            animate="visible"
          >
            Learn More
          </motion.button>
        </div>
      </div>

      {/* Call-to-Action Sidebar */}
      <motion.div
        className="absolute right-0 top-0 h-full bg-gradient-to-l bg-black text-green-400 font-bold text-lg p-6 flex items-center writing-mode-vertical-rl"
        initial={{ x: 100, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <p className="tracking-wide text-3xl">DR Cultivar</p>
      </motion.div>
    </div>
  );
};

export default Herosection;
